import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import length from '@turf/length'
import { Icon } from 'components/Icon'
import { Text } from 'components/Text'
import { readableNumber } from 'utils/readableNumber'
import { Flex } from 'components/Flex'
import { useMapEditorContext } from 'context/map-editor-context'
import styles from './MeasureTool.module.scss'
import { Button } from 'components/Button'

export const MeasureTool: FC = () => {
  const { t } = useTranslation()
  const [{ editor }, mapEditorDispatch] = useMapEditorContext()
  const selectedFeature = editor.feature

  const totalLength = selectedFeature
    ? readableNumber(length(selectedFeature as any, { units: 'kilometers' }))
    : 0

  return (
    <Flex justify="between" align="center" gap="md" className={styles.measureTool}>
      <Flex justify="center" align="center" className={styles.icon}>
        <Icon name="ruler-2-line" />
      </Flex>
      <div>
        <Text className={styles.title} weight="strong">
          {t('measure_tool.title')}
        </Text>
        <Text>{totalLength} km</Text>
      </div>
      <Button variant="danger" onClick={mapEditorDispatch.cancelWizard}>
        {t('confirmation_banner.cancel')}
      </Button>
    </Flex>
  )
}

MeasureTool.displayName = 'MeasureTool'
